import { useState } from 'react';
import { Check, Copy, KeyRound } from 'lucide-react';
import Button from './Button';
import Modal from './Modal';

function InitialCredentialsModal({ credentials, onClose }) {
  const [copied, setCopied] = useState(false);
  if (!credentials) return null;

  const copyCredentials = async () => {
    await navigator.clipboard.writeText(
      `Usuario: ${credentials.username}\nContraseña inicial: ${credentials.initialPassword}`
    );
    setCopied(true);
  };

  return (
    <Modal
      open
      onClose={onClose}
      title="Credenciales iniciales"
      description={credentials.mustChangePassword
        ? 'Estas credenciales se muestran una sola vez. El usuario deberá cambiar la contraseña al ingresar.'
        : 'Estas credenciales se muestran una sola vez y ya pueden utilizarse para ingresar.'}
      footer={<Button onClick={onClose}>Entendido</Button>}
    >
      <div className="rounded-control border border-warning-200 bg-warning-50 p-4">
        <div className="flex items-center gap-2 text-sm font-semibold text-warning-900">
          <KeyRound className="size-4" />
          Guarda o entrega estas credenciales de forma segura
        </div>
        <dl className="mt-4 space-y-3 text-sm">
          <div>
            <dt className="text-content-muted">Usuario</dt>
            <dd className="mt-1 font-mono font-semibold text-content-primary">{credentials.username}</dd>
          </div>
          <div>
            <dt className="text-content-muted">Contraseña inicial</dt>
            <dd className="mt-1 font-mono font-semibold text-content-primary">{credentials.initialPassword}</dd>
          </div>
        </dl>
      </div>
      <Button variant="secondary" className="mt-4 w-full" onClick={copyCredentials}>
        {copied ? <Check className="size-4" /> : <Copy className="size-4" />}
        {copied ? 'Credenciales copiadas' : 'Copiar credenciales'}
      </Button>
    </Modal>
  );
}

export default InitialCredentialsModal;
